function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.6284 3.57168L9.54143 2.48468C7.39355 0.336801 3.91114 0.336801 1.76326 2.48468C-0.384627 4.63257 -0.384627 8.11498 1.76326 10.2629L10.6021 19.1017L10.6039 19.0999L10.6302 19.1262L19.4691 10.2874C21.6169 8.13951 21.6169 4.6571 19.4691 2.50922C17.3212 0.361337 13.8388 0.361337 11.6909 2.50922L10.6284 3.57168ZM10.6039 16.2715L15.5401 11.3352L16.9909 9.9342L16.9924 9.93564L18.0548 8.87318C19.4217 7.50635 19.4217 5.29027 18.0548 3.92343C16.688 2.5566 14.4719 2.5566 13.1051 3.92343L10.6295 6.39903L10.6223 6.39179L10.6212 6.39287L8.12722 3.8989C6.76038 2.53206 4.5443 2.53206 3.17747 3.8989C1.81063 5.26573 1.81063 7.48181 3.17747 8.84865L5.7169 11.3881L5.71869 11.3863L10.6039 16.2715Z",
  fill: "#4979C0"
});

var SvgBeneficiaries = function SvgBeneficiaries(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeneficiaries, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/beneficiaries.e5cd53f1.svg";
export { ForwardRef as ReactComponent };